
export const CustomCheckboxIconChecked = ({ tickColor = '#1976d2' }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <rect x="1.5" y="1.5" width="17" height="17" rx="2" fill="white" stroke="#C9CACC" strokeWidth="1.5" />
    <path
      d="M5 10L8.5 13.5L15 7"
      stroke={tickColor}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomCheckboxIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <rect x="1.5" y="1.5" width="17" height="17" rx="2" fill="white" stroke="#C9CACC" strokeWidth="1.5" />
  </svg>
);